import { createSlice } from "@reduxjs/toolkit";

import { getBlogCategoryApi } from "../../reduxApi/admin/BlogCategoryReducApi";
import { getBlogListApi } from "../../reduxApi/admin/BlogListReduxApi";
import { getBrandListApi } from "../../reduxApi/admin/BrandReduxApi";

const BrandSlice = createSlice({
  name: "PurchaseOders",
  initialState: {
    status: "idle",
    getBrandList: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getBrandListApi.fulfilled, (state, action) => {
      state.status = "fulfilled";
      state.getBrandList = action.payload.data;
      console.log("state.getBrandList", state.getBrandList);
    });
  },
});

export default BrandSlice.reducer;
